const STREET_PREFIX_PATTERN = /^(ulica|ul\.?|al\.?|aleja|pl\.?|plac|os\.?|osiedle|skwer|skw\.?|rondo|r\.?)\s+/i;
const POLAND_SUFFIX_PATTERN = /,?\s*polska\s*$/i;
const POSTAL_CODE_PATTERN = /\b\d{2}-\d{3}\b/;

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const normalizeAddressForGeocode = (address) => {
  if (!address) return '';
  return address.trim().replace(STREET_PREFIX_PATTERN, '').trim();
};

export const parseClientAddressParts = (client) => {
  let street = normalizeAddressForGeocode(client?.address || '');
  let postalCode = client?.postalCode?.trim() || '';
  let city = client?.city?.trim() || '';

  street = street.replace(POLAND_SUFFIX_PATTERN, '').trim();

  if (postalCode && city) {
    const duplicatedSuffix = new RegExp(
      `,\\s*${escapeRegExp(postalCode)}\\s*,?\\s*${escapeRegExp(city)}\\s*$`,
      'i'
    );
    street = street.replace(duplicatedSuffix, '').trim();
  }

  if (!postalCode) {
    const postalMatch = street.match(POSTAL_CODE_PATTERN);
    if (postalMatch) {
      postalCode = postalMatch[0];
    }
  }

  if (!city && postalCode) {
    const cityMatch = street.match(new RegExp(`${escapeRegExp(postalCode)}\\s+(.+)$`, 'i'));
    if (cityMatch?.[1]) {
      city = cityMatch[1].trim();
      street = street.replace(new RegExp(`\\s*,?\\s*${escapeRegExp(postalCode)}\\s+${escapeRegExp(city)}\\s*$`, 'i'), '').trim();
    }
  }

  street = street.replace(/,\s*$/, '').trim();

  return { street, postalCode, city };
};

export const buildClientGeocodeQueryVariants = (client) => {
  const { street, postalCode, city } = parseClientAddressParts(client);
  const cityLine = [postalCode, city].filter(Boolean).join(' ');
  const variants = [];

  if (street && city) {
    variants.push(`street:${street}|city:${city}|postal:${postalCode || ''}`);
  }

  if (street && cityLine) {
    variants.push(`${street}, ${cityLine}, Polska`);
  } else if (street) {
    variants.push(`${street}, Polska`);
  }

  if (cityLine) {
    variants.push(`${cityLine}, Polska`);
  }

  if (city) {
    variants.push(`${city}, Polska`);
  }

  return [...new Set(variants.filter(Boolean))];
};

export const buildClientGeocodeQuery = (client) => {
  const variants = buildClientGeocodeQueryVariants(client);
  const first = variants[0] || '';
  if (first.startsWith('street:')) {
    const { street, postalCode, city } = parseClientAddressParts(client);
    const cityLine = [postalCode, city].filter(Boolean).join(' ');
    if (street && cityLine) return `${street}, ${cityLine}, Polska`;
    if (street) return `${street}, Polska`;
    return cityLine ? `${cityLine}, Polska` : '';
  }
  return first;
};

export const hasGeocodableAddress = (client) =>
  Boolean(buildClientGeocodeQuery(client));

export const mergeClientWithDetails = (client, details) => ({
  id: client.id,
  companyName: details?.companyName || client.companyName || '',
  city: details?.city || client.city || '',
  address: details?.address || client.address || '',
  postalCode: details?.postalCode || client.postalCode || '',
  status: details?.status || client.status || '',
});
